var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M11 4.201L7.003 3.928 5.498 0 3.993 3.928 0 4.201 3.062 6.903 2.057 11 5.498 8.741 8.938 11 7.933 6.903z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultStar);
export default __webpack_public_path__ + "static/media/default-star.5dcf36efbeabeb54f7d7eeccfd688008.svg";
export { ForwardRef as ReactComponent };